"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUuid = void 0;
const uuid_1 = require("uuid");
// TODO: replace this redundancy with 'the createUuid()' from 'utils/uuid.ts'
const createUuid = () => (0, uuid_1.v4)();
exports.createUuid = createUuid;
